import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableHead, TableRow } from '@material-ui/core';

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };
  render() {
    return (
      <TableHead style={{ textAlignLast: 'center' }}>
        <TableRow>
          {this.props.columnData.map(
            column => <TableCell style={{ padding: '0 5px 0 5px' }}>{column.label}</TableCell>,
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  columnData: PropTypes.object,
};

export default EnhancedTableHead;



// WEBPACK FOOTER //
// ./src/components/orders/EnhancedTableHead.js